import { render, staticRenderFns } from "./OnboardingStepColaborador.vue?vue&type=template&id=f439a01e"
import script from "./OnboardingStepColaborador.vue?vue&type=script&lang=js"
export * from "./OnboardingStepColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports